import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Link from '../../Core/Link';

export const ArticleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  h2 {
    margin-bottom: 2.5rem;
    font-size: 1.5rem;
    line-height: 2rem;
    width: 100%;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 2rem;
      line-height: 3rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 2.625rem;
      line-height: 4rem;
    }
  }
`;

export const Article = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 2.5rem;
  width: 100%;

  * {
    &:last-child {
      margin-bottom: 0;
    }
  }

  h3 {
    font-size: 1.125rem;
    line-height: 2.5rem;
    margin-bottom: 1.5rem;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 1.5rem;
      line-height: 2rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 2rem;
      line-height: 2.5rem;
    }
  }

  p,
  ol,
  ul,
  li {
    margin-bottom: 2rem;
    font-size: 1.125rem;
    line-height: 2rem;
    width: 100%;
  }

  ol,
  ul {
    padding-left: 0.75rem;
  }

  li {
    margin-bottom: 0;
  }

  /* @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding-bottom: 40px;
  } */
`;

export const AdditionalArticles = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid rgba(116, 119, 112, 0.5);
  padding-top: 2.5rem;

  & ${Article} {
    border-bottom: 1px solid rgba(116, 119, 112, 0.5);
    padding-bottom: 2.5rem;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }
`;

export const Ctas = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  a {
    margin: 1rem 0;
  }
`;

export const StyledLink = styled(Link)`
  font-weight: ${themeGet('fontWeights.normal')};
  line-height: 2rem;
  p {
    color: ${themeGet('colors.teal')};
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

export const PaginationBtn = styled.button`
  color: ${themeGet('colors.teal')};
  font-weight: ${themeGet('fontWeights.normal')};
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0px;
  margin: 1rem;
  padding-right: 20px;
  position: relative;

  span {
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    padding-bottom: 5px;
    border-bottom: 1px solid currentColor;
  }

  &:hover {
    color: ${themeGet('colors.secondary-teal')};
  }

  &:after {
    content: '';
    display: inline-block;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    width: 11px;
    height: 11px;
    transform: rotate(45deg) translate(-50%, -50%);
    position: absolute;
    right: 0;
    top: 50%;
  }

  &.hide {
    &:after {
      content: '';
      transform: rotate(-135deg) translate(-50%, -50%);
      top: 15%;
    }
  }
`;
